/* Keep native Shopify values intact; clean only customer-facing color text. */
(() => {
  const watched = new WeakSet();
  function initialize(root) {
    const fields = root.matches?.('fieldset[data-winchi-color]') ? [root] : root.querySelectorAll?.('fieldset[data-winchi-color]') || [];
    fields.forEach(field => {
      if (watched.has(field)) return;
      watched.add(field);
      const clean = () => {
        const labels = new Map(Array.from(field.querySelectorAll('[data-winchi-color-label]'), input => [input.getAttribute('value'), input.dataset.winchiColorLabel]));
        field.querySelectorAll('[update-value], .hdt-select').forEach(label => {
          const display = labels.get(label.textContent.trim());
          if (display && display !== label.textContent) label.textContent = display;
        });
      };
      clean();
      new MutationObserver(clean).observe(field, {childList:true, characterData:true, subtree:true});
    });
  }
  initialize(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) initialize(node);
  }))).observe(document.documentElement, {childList:true, subtree:true});
})();
